// extracted by mini-css-extract-plugin
module.exports = {"canvasContainer":"Flatmap_canvasContainer__2hd5l","flatmap":"Flatmap_flatmap__3Swo-","loadingIndicator":"Flatmap_loadingIndicator__FGlmB"};